import React from 'react';
import Section from './Section';
import { messages } from './messages';
import { formatTime } from './time-utils';
var SingleStopView = function (_a) {
    var display = _a.display, tripStatus = _a.tripStatus, color = _a.color;
    var lastStop = display.upcomingStops.length === 1;
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(Section, { color: color, line: lastStop ? 'none' : 'arrow' },
            React.createElement("div", { style: { fontSize: 40, color: '#585858', fontWeight: 300 } }, display.atStop ? messages.currentStop : lastStop ? messages.terminus : messages.nextStop)),
        React.createElement(Section, { color: color, stopPosition: 65, line: lastStop ? 'terminate' : 'full', flex: true },
            React.createElement("div", { style: { fontSize: 108, fontWeight: 500 } }, display.nextStopName),
            display.nextStop !== null && (!display.atStop || display.atFirstStop || hasWaitTime(display.nextStop)) && (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { fontSize: 40, color: '#585858', fontWeight: 300 } }, display.atStop ? messages.departure : messages.predictedArrival),
                React.createElement("div", { style: { fontSize: 60, fontWeight: 500 } }, formatRemainingTime(getRelevantTimestamp(display.nextStop, display.atStop, tripStatus))))))));
};
function hasWaitTime(nextStop) {
    return nextStop.scheduledDeparture !== nextStop.scheduledArrival;
}
function getRelevantTimestamp(nextStop, atStop, tripStatus) {
    var baseTime = nextStop[atStop ? 'scheduledDeparture' : 'scheduledArrival'];
    var delay = (tripStatus && tripStatus.delay) || 0;
    return (baseTime + delay) * 1000;
}
function formatRemainingTime(timeMs) {
    var remainingMs = timeMs - Date.now();
    var minutes = Math.round(remainingMs / 60000);
    if (minutes <= 0) {
        return messages.now;
    }
    return formatTime(new Date(timeMs)) + ", " + minutes + " " + (minutes > 1 ? messages.minutes : messages.minute);
}
export default SingleStopView;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/SingleStopView.tsx
// module id = 1846
// module chunks = 0